import { render, staticRenderFns } from "./StatusTag.vue?vue&type=template&id=0834c621&scoped=true&"
import script from "./StatusTag.vue?vue&type=script&lang=ts&"
export * from "./StatusTag.vue?vue&type=script&lang=ts&"
import style0 from "./StatusTag.vue?vue&type=style&index=0&id=0834c621&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0834c621",
  null
  
)

export default component.exports